import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { LotController } from 'src/controllers/lot.controller'
import { LotDto } from 'src/dto/lot.dto'

const lotController = new LotController()

export function useGetLotList() {
  const { userFarm: farmId } = useAuth()

  return useQuery<LotDto[], Error>({
    queryKey: ['getLotList', farmId],
    queryFn: () => lotController.getLotListByFarmId(farmId!),
    enabled: !!farmId
  })
}
